import axios from '../axios'

// 受講登録の作成（admin/teacher・冪等）
const postEnrollmentApi = async (studentId, courseId) => {
  return await axios.post('api/lms/enrollments', { student_id: studentId, course_id: courseId })
}

export default postEnrollmentApi
